/* eslint-disable no-undef */

// import { error, success } from '../../notification';

import { error, notifyResponseError, success } from '../notification';
import request from '../axios';
import { API } from '../../constants';
import { get } from 'lodash';

export const getWorklogs = (momentDate, username) =>
  request
    .get(
      `${API.WORKLOGS}?username=${username}&year=${momentDate.format(
        'YYYY'
      )}&month=${momentDate.format('MM')}`
    )
    .then((res) => get(res, 'data.results', []));

export const getWorklogById = (id) =>
  request
    .get(`${API.WORKLOGS}${id}/`)
    .then((res) => res.data)
    .catch((e) => {
      notifyResponseError(e);
      throw e;
    });

export const getWorklogTotalHours = (month, year, username, signal) =>
  request
    .get(
      `${API.WORKLOGS}total/?year=${year}&month=${month}&username=${username}`,
      { signal }
    )
    .then((res) => res.data)
    .catch((e) => {
      notifyResponseError(e);
      return null;
    });


export const deleteWorklogById = ({ id }) =>
  request
    .delete(`${API.WORKLOGS}${id}/`)
    .then((res) => {
      success('Esito', 'Cancellazione avvenuta con successo');
      return res.data;
    })
    .catch((e) => {
      error('Errore', 'Cancellazione fallita');
      throw e;
    });

export const updateWorklogDay = (data) =>
  request
    .put(`${API.WORKLOGS}${data.id}/`, data)
    .then((response) => {
      success('Esito', 'Aggiornamento eseguito con successo');
      return response;
    })
    .catch((e) => {
      notifyResponseError(e);
      throw e;
    });

export const createWorklogDay = (data) =>
  request
    .post(API.WORKLOGS, data)
    .then((response) => {
      success('Esito', 'Salvataggio riuscito');
      return response.data;
    })
    .catch((e) => {
      notifyResponseError(e);
      throw e;
    });

export const createMultipleWorklogs = (data) =>
  request
    .post(API.MULTIPLE_WORKLOGS, { worklogs: data })
    .then(() => {
      success('Esito', 'Salvataggio riuscito');
    })
    .catch((e) => {
      notifyResponseError(e);
      throw e;
    });

export const getWorklogIssueHoursSummary = (year, month, username) =>
  request
    .get(
      `${API.WORKLOGS_ISSUE_HOURS_SUMMARY}?year=${year}&month=${month}&username=${username}`
    )
    .then((res) => res.data)
    .catch((e) => {
      // Non mostrare errore se l'endpoint non è ancora disponibile
      console.warn('Issue hours summary endpoint not available:', e);
      return null;
    });
